"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _getIntegrationPath = _interopRequireDefault(require("../common/getIntegrationPath"));

var _getQueryUtils = _interopRequireDefault(require("../common/getQueryUtils"));

var _getRjsConfig = _interopRequireDefault(require("./get-rjs-config"));

var _isLocal = _interopRequireDefault(require("../common/isLocal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param window
 * @param {*} versions
 * @param {boolean} experiment
 * @returns {getViewerRjsConfig}
 */
function _default(window, versions, experiment) {
  function getViewerRjsConfig(serviceTopology) {
    var queryUtils = (0, _getQueryUtils["default"])(window); // const clientSpecMap = window.rendererModel && window.rendererModel.clientSpecMap

    var local = ((0, _isLocal["default"])(queryUtils.getParameterByName('ReactSource')) || (0, _isLocal["default"])(window.santaBase)) && !queryUtils.getParameterByName('isBisect'); // const nativeComponentsOverrides = queryUtils.getParameterByName('nativeComponentsOverrides')

    var rr = (0, _getRjsConfig["default"])(versions, serviceTopology, local, experiment);

    if (!experiment) {
      rr.paths.experiment = 'js/plugins/experiment/experiment';
    } // generated


    rr.packages = ['tpaIntegration', 'wixCodeIntegration', 'viewerIntegration'].map(function (packageName) {
      return {
        name: packageName,
        main: packageName,
        location: (0, _getIntegrationPath["default"])(packageName, window.santaBase)
      };
    });
    return rr;
  }

  return getViewerRjsConfig;
}
//# sourceMappingURL=rjs-config.js.map